<template lang="pug">
  .flex.flex-col.bg-white(class="lg:flex-row")
    component(:is="$screen.lg ? 'div' : 'sw-collapse'" custom-classes="bg-gray-100 shadow-xs mt-12 py-3 px-10 sm:px-12" icon-custom-classes="order-first")
      p.ml-2.font-semibold(v-show="!$screen.lg") Sidebar Navigation
      Sidebar(class="lg:w-56 lg:pt-12 xl:pt-20" slot="in-collapse")
    .w-full.pt-6(class="lg:pt-24 xl:pt-32")
      router-view.px-6.pt-4.mx-auto(class="sm:px-10 lg:max-w-screen-md lg:px-20 xl:max-w-screen-xxl xl:px-12")
</template>

<script>
  import Sidebar from './shared/sidebar';

  export default {
    name: 'Documentation',
    components: {
      Sidebar,
    },
  };
</script>
